import { environment } from './environments/environment';

let AWSConfiguration = {};

AWSConfiguration.aws_user_pools_id = 'eu-west-1_3NzbaaraI';
AWSConfiguration.aws_user_pools_web_client_id = '4dsiphkak20r7a121tnhtdvic1';
AWSConfiguration.domain = 'auth.users.qa.gitobaccotracing.com';
AWSConfiguration.redirectSignOut = 'http://localhost:4200/landing-page';

if (environment.qa) {
  AWSConfiguration.aws_user_pools_id = 'eu-west-1_3NzbaaraI';
  AWSConfiguration.aws_user_pools_web_client_id = '4dsiphkak20r7a121tnhtdvic1';
  AWSConfiguration.domain = 'auth.users.qa.gitobaccotracing.com';
  AWSConfiguration.redirectSignOut = 'https://portal.qa.gitobaccotracing.com/landing-page';
}

if (environment.pre) {
  AWSConfiguration.aws_user_pools_id = 'eu-west-1_1kXkYQYi5';
  AWSConfiguration.aws_user_pools_web_client_id = '85nvein8nq7eq8mkbrhd9rd24';
  AWSConfiguration.domain = 'auth.users.pre.gitobaccotracing.com';
  AWSConfiguration.redirectSignOut = 'https://portal.pre.gitobaccotracing.com/landing-page';
}

if (environment.production) {
  AWSConfiguration.aws_user_pools_id = 'eu-west-1_DwWRKgmqS';
  AWSConfiguration.aws_user_pools_web_client_id = '29a9158ad25msqhqdsf4akfels';
  AWSConfiguration.domain = 'auth.users.gitobaccotracing.com';
  AWSConfiguration.redirectSignOut = 'https://portal.gitobaccotracing.com/landing-page';
}

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": AWSConfiguration.aws_user_pools_id,
    "aws_user_pools_web_client_id": AWSConfiguration.aws_user_pools_web_client_id,
    "oauth": {
        "domain": AWSConfiguration.domain,
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": AWSConfiguration.redirectSignIn,
        "redirectSignOut": AWSConfiguration.redirectSignOut,
        "responseType": "code"
    }
};

export default awsmobile;
